export default __webpack_public_path__ + "static/media/logo-splash.117faaa0.png";